import angular from 'angular';

import RwTrackingNumberComponent from './rw-tracking-number-component';

export default angular.module('rw-tracking-number', []).component('rwTrackingNumber', new RwTrackingNumberComponent());



// WEBPACK FOOTER //
// ./src/modules/utils/rw-tracking-number/rw-tracking-number-module.js